import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { changeMyPassword } from '../../services/accountApi';
import { friendlyError } from '../../utils/errors';

const MIN_LENGTH = 8;

export default function AccountPassword() {
  const { user } = useAuth();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [reveal, setReveal] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      return setError('Please fill in all three fields.');
    }
    if (newPassword.length < MIN_LENGTH) {
      return setError(`New password must be at least ${MIN_LENGTH} characters.`);
    }
    if (newPassword !== confirmPassword) {
      return setError('New password and confirmation do not match.');
    }
    if (newPassword === currentPassword) {
      return setError('New password must be different from the current one.');
    }

    setBusy(true);
    const { error } = await changeMyPassword({
      email: user.email,
      currentPassword,
      newPassword,
    });
    setBusy(false);

    if (error) return setError(friendlyError(error));

    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setSuccess('Password updated. Use it next time you sign in.');
  };

  return (
    <div>
      <h3 className="account-h3">Change Password</h3>

      <form className="account-form boxed" onSubmit={handleSubmit}>
        <p className="field-hint">
          We ask for your current password to confirm it's really you.
        </p>

        <label>
          Current Password
          <input
            type={reveal ? 'text' : 'password'}
            value={currentPassword}
            autoComplete="current-password"
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </label>

        <label>
          New Password
          <input
            type={reveal ? 'text' : 'password'}
            value={newPassword}
            autoComplete="new-password"
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder={`At least ${MIN_LENGTH} characters`}
          />
        </label>

        <label>
          Confirm New Password
          <input
            type={reveal ? 'text' : 'password'}
            value={confirmPassword}
            autoComplete="new-password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </label>

        <label className="check-inline">
          <input
            type="checkbox"
            checked={reveal}
            onChange={(e) => setReveal(e.target.checked)}
          />
          Show passwords
        </label>

        {error && <p className="account-error">{error}</p>}
        {success && <p className="account-success">{success}</p>}

        <button className="account-btn" disabled={busy}>
          {busy ? 'Updating…' : 'Update Password'}
        </button>
      </form>
    </div>
  );
}
